import {React, Fragment } from 'react';
import { clsx } from 'clsx';

function CoolyMapItemsListTabs({ itemType, updateItemType }) {

    return <Fragment>
    {/* <div className="
      hidden md:block
      pt-6 pb-3
      pl-4 md:pl-12
      md:-translate-x-1
      text-white _dark:text-neutral_d font-black
      text-lg
    ">
      Entdecke:
    </div> */}

    <div className="
      h-10 overflow-hidden
      md:h-auto
      shrink-0
    ">
      <div className="
        pt-2 md:pt-3
        px-2 md:px-3
        pb-8 md:pb-2
        flex space-x-2
        overflow-x-auto md:overflow-visible
        tabs
      ">
        <h1
          className={clsx(`
            block
            font-black uppercase tracking-wide text-center
            px-2 md:px-3 md:py-1 rounded-md
            cursor-pointer select-none
            `,
            { 'text-white hover:text-neutral_d': itemType != 'club_event' },
            { 'bg-neutral_d hover:bg-white': itemType != 'club_event' },
            { 'text-neutral_d bg-white grow': itemType == 'club_event' },
          )}
          onClick={() => {
            if (itemType != 'club_event') {
              updateItemType('club_event');
            }
          }}
        >
          Grouprides
        </h1>

        <span
          className={clsx(`
          block
          font-black uppercase tracking-wide text-center
          px-2 md:px-3 md:py-1 rounded-md
          cursor-pointer select-none
          `,
            { 'text-white hover:text-neutral_d': itemType != 'coffeeshop' },
            { 'bg-neutral_d hover:bg-white': itemType != 'coffeeshop' },
            { 'text-neutral_d bg-white grow': itemType == 'coffeeshop' },
          )}
          onClick={() => {
            if (itemType != 'coffeeshop') {
              updateItemType('coffeeshop');
            }
          }}
        >
          Café
        </span>

        <span
          className={clsx(`
            block
            font-black uppercase tracking-wide text-center
            px-2 md:px-3 md:py-1 rounded-md
            cursor-pointer select-none
            `,
            { 'text-white hover:text-neutral_d': itemType != 'pizza' },
            { 'bg-neutral_d hover:bg-white': itemType != 'pizza' },
            { 'text-neutral_d bg-white grow': itemType == 'pizza' },
          )}
          onClick={() => {
            if (itemType != 'pizza') {
              updateItemType('pizza');
            }
          }}
        >
          Pizza
        </span>

        <span
          className={clsx(`
            block
            font-black uppercase tracking-wide text-center
            px-2 md:px-3 md:py-1 rounded-md
            cursor-pointer select-none
            `,
            { 'text-white hover:text-neutral_d': itemType != 'bikeshop' },
            { 'bg-neutral_d hover:bg-white': itemType != 'bikeshop' },
            { 'text-neutral_d bg-white grow': itemType == 'bikeshop' },
          )}
          onClick={() => {
            if (itemType != 'bikeshop') {
              updateItemType('bikeshop');
            }
          }}
        >
          Shops
        </span>

        {/* <span
          className={clsx(`
            block
            font-black uppercase tracking-wide text-center
            border border-primary _dark:border-white
            px-2 rounded-full
            cursor-pointer select-none
            `,
            { 'text-primary hover:text-white _dark:text-neutral_ll _dark:hover:text-neutral_dd': itemType != 'events' },
            { 'text-white _dark:text-neutral_dd': itemType == 'events' },
            { 'bg-white hover:bg-primary _dark:bg-neutral_dd _dark:hover:bg-neutral_ll': itemType != 'events' },
            { 'bg-primary _dark:bg-neutral_ll': itemType == 'events' },
          )}
          onClick={() => {
            if (itemType != 'events') {
              updateItemType('events');
            }
          }}
        >
          Events
        </span> */}
      </div>
    </div>
  </Fragment>
}

export default CoolyMapItemsListTabs;
